/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Contract Management API
 * API for Contract management UI.
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as zod from 'zod';


/**
 * Gets contracts by search text or VIN, up to the required limit, with the total number of matching contracts.
 * @summary Gets contracts by search criteria and required limit
 */
export const getContractsQueryQMin = 3;
export const getContractsQueryQMax = 200;

export const getContractsQueryVinMin = 8;
export const getContractsQueryVinMax = 17;

export const getContractsQueryLimitMax = 200;



export const GetContractsQueryParams = zod.object({
  "q": zod.string().min(getContractsQueryQMin).max(getContractsQueryQMax).optional().describe('Search text, at least three characters. Matches, case-insensitively, a contract id, a VIN or its last eight characters exactly, or a policy number or dealer account it starts.'),
  "vin": zod.string().min(getContractsQueryVinMin).max(getContractsQueryVinMax).optional().describe('Optional VIN filter. Can be full VIN or chassis suffix.'),
  "limit": zod.number().min(1).max(getContractsQueryLimitMax).describe('Required limit to protect API from large pulls.')
})

export const getContractsResponseContractsItemVinMin = 8;
export const getContractsResponseContractsItemVinMax = 17;

export const getContractsResponseContractsItemPaymentAgreementOneAgreementIdMin = 3;
export const getContractsResponseContractsItemPaymentAgreementOneAgreementIdMax = 32;

export const getContractsResponseContractsItemPaymentAgreementOneCustomerAgreementIdMin = 3;
export const getContractsResponseContractsItemPaymentAgreementOneCustomerAgreementIdMax = 64;

export const getContractsResponseContractsItemPaymentAgreementOneDealerAgreementIdMin = 3;
export const getContractsResponseContractsItemPaymentAgreementOneDealerAgreementIdMax = 64;

export const getContractsResponseContractsItemPolicyNumberMax = 100;

export const getContractsResponseContractsItemDealerAccountRegExp = new RegExp('^[0-9]{6}$');
export const getContractsResponseContractsItemCustomerNameOneMax = 200;

export const getContractsResponseContractsItemContractStartOdometerValueMin = 0;

export const getContractsResponseContractsItemContractEndOdometerValueMin = 0;

export const getContractsResponseContractsItemContractEngineHoursLimitMin = 0;

export const getContractsResponseTotalMin = 0;



export const GetContractsResponse = zod.object({
  "contracts": zod.array(zod.object({
  "id": zod.uuid(),
  "vin": zod.string().min(getContractsResponseContractsItemVinMin).max(getContractsResponseContractsItemVinMax),
  "paymentAgreement": zod.object({
  "agreementId": zod.string().min(getContractsResponseContractsItemPaymentAgreementOneAgreementIdMin).max(getContractsResponseContractsItemPaymentAgreementOneAgreementIdMax),
  "customerAgreementId": zod.string().min(getContractsResponseContractsItemPaymentAgreementOneCustomerAgreementIdMin).max(getContractsResponseContractsItemPaymentAgreementOneCustomerAgreementIdMax),
  "dealerAgreementId": zod.string().min(getContractsResponseContractsItemPaymentAgreementOneDealerAgreementIdMin).max(getContractsResponseContractsItemPaymentAgreementOneDealerAgreementIdMax),
  "planStatus": zod.enum(['Active', 'Cancelled']).describe('Active means the contract is paid over time.')
}).describe('The payment agreement the contract was sold under, found through its VIN and policy (directly or as part of a bundle).').nullable(),
  "policyNumber": zod.string().min(1).max(getContractsResponseContractsItemPolicyNumberMax),
  "coverageType": zod.string().nullable().nullable(),
  "dealerAccount": zod.string().regex(getContractsResponseContractsItemDealerAccountRegExp),
  "customerName": zod.string().min(1).max(getContractsResponseContractsItemCustomerNameOneMax).nullable(),
  "startDate": zod.iso.date(),
  "expiryDate": zod.iso.date(),
  "cancellationDate": zod.iso.date().nullable(),
  "contractStartOdometer": zod.object({
  "value": zod.number().min(getContractsResponseContractsItemContractStartOdometerValueMin),
  "unit": zod.enum(['miles', 'kilometers'])
}),
  "contractEndOdometer": zod.object({
  "value": zod.number().min(getContractsResponseContractsItemContractEndOdometerValueMin),
  "unit": zod.enum(['miles', 'kilometers'])
}),
  "contractEngineHoursLimit": zod.number().min(getContractsResponseContractsItemContractEngineHoursLimitMin).nullish()
})),
  "total": zod.number().min(getContractsResponseTotalMin)
})

/**
 * @summary Gets contract details by contract id
 */
export const GetContractByIdParams = zod.object({
  "contractId": zod.uuid().describe('Contract id')
})

export const getContractByIdResponsePaymentAgreementOneAgreementIdMin = 3;
export const getContractByIdResponsePaymentAgreementOneAgreementIdMax = 32;

export const getContractByIdResponsePaymentAgreementOneCustomerAgreementIdMin = 3;
export const getContractByIdResponsePaymentAgreementOneCustomerAgreementIdMax = 64;

export const getContractByIdResponsePaymentAgreementOneDealerAgreementIdMin = 3;
export const getContractByIdResponsePaymentAgreementOneDealerAgreementIdMax = 64;

export const getContractByIdResponseVinMin = 8;
export const getContractByIdResponseVinMax = 17;

export const getContractByIdResponseDealerNameOneMax = 200;

export const getContractByIdResponseDealerAccountRegExp = new RegExp('^[0-9]{6}$');
export const getContractByIdResponseCustomerNameOneMax = 200;

export const getContractByIdResponseCustomerIdOneMin = 5;
export const getContractByIdResponseCustomerIdOneMax = 100;

export const getContractByIdResponsePolicyNumberMax = 100;

export const getContractByIdResponseContractStartOdometerValueMin = 0;

export const getContractByIdResponseContractEndOdometerValueMin = 0;

export const getContractByIdResponseContractEngineHoursLimitMin = 0;

export const getContractByIdResponseContractSoldPriceCurrencyMin = 2;
export const getContractByIdResponseContractSoldPriceCurrencyMax = 3;

export const getContractByIdResponseContractSoldPriceAmountMultipleOf = 0.01;

export const getContractByIdResponseCoverageItemCoverageDescriptionMax = 4000;

export const getContractByIdResponseCoverageItemPolicyNumberMax = 100;

export const getContractByIdResponseVehicleModelYearMin = 0;



export const GetContractByIdResponse = zod.object({
  "paymentAgreement": zod.object({
  "agreementId": zod.string().min(getContractByIdResponsePaymentAgreementOneAgreementIdMin).max(getContractByIdResponsePaymentAgreementOneAgreementIdMax),
  "customerAgreementId": zod.string().min(getContractByIdResponsePaymentAgreementOneCustomerAgreementIdMin).max(getContractByIdResponsePaymentAgreementOneCustomerAgreementIdMax),
  "dealerAgreementId": zod.string().min(getContractByIdResponsePaymentAgreementOneDealerAgreementIdMin).max(getContractByIdResponsePaymentAgreementOneDealerAgreementIdMax),
  "planStatus": zod.enum(['Active', 'Cancelled']).describe('Active means the contract is paid over time.')
}).describe('The payment agreement the contract was sold under, found through its VIN and policy (directly or as part of a bundle).').nullable(),
  "id": zod.uuid(),
  "vin": zod.string().min(getContractByIdResponseVinMin).max(getContractByIdResponseVinMax),
  "dealerName": zod.string().min(1).max(getContractByIdResponseDealerNameOneMax).nullable(),
  "dealerAccount": zod.string().regex(getContractByIdResponseDealerAccountRegExp),
  "customerName": zod.string().min(1).max(getContractByIdResponseCustomerNameOneMax).nullable(),
  "customerId": zod.string().min(getContractByIdResponseCustomerIdOneMin).max(getContractByIdResponseCustomerIdOneMax).nullable(),
  "policyNumber": zod.string().min(1).max(getContractByIdResponsePolicyNumberMax),
  "registrationDate": zod.iso.date(),
  "startDate": zod.iso.date(),
  "expiryDate": zod.iso.date(),
  "cancellationDate": zod.iso.date().nullish(),
  "contractStartOdometer": zod.object({
  "value": zod.number().min(getContractByIdResponseContractStartOdometerValueMin),
  "unit": zod.enum(['miles', 'kilometers'])
}),
  "contractEndOdometer": zod.object({
  "value": zod.number().min(getContractByIdResponseContractEndOdometerValueMin),
  "unit": zod.enum(['miles', 'kilometers'])
}),
  "contractEngineHoursLimit": zod.number().min(getContractByIdResponseContractEngineHoursLimitMin).nullish(),
  "contractSoldPrice": zod.object({
  "currency": zod.string().min(getContractByIdResponseContractSoldPriceCurrencyMin).max(getContractByIdResponseContractSoldPriceCurrencyMax),
  "amount": zod.number().multipleOf(getContractByIdResponseContractSoldPriceAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "coverage": zod.array(zod.object({
  "coverageType": zod.string().nullish(),
  "coverageDescription": zod.string().min(1).max(getContractByIdResponseCoverageItemCoverageDescriptionMax).nullish(),
  "policyNumber": zod.string().min(1).max(getContractByIdResponseCoverageItemPolicyNumberMax)
})),
  "vehicle": zod.object({
  "modelYear": zod.number().min(getContractByIdResponseVehicleModelYearMin).nullish(),
  "deliveryDate": zod.iso.date().nullish(),
  "lastRecordedOdometer": zod.number().nullish(),
  "lastRecordedEngineHours": zod.number().nullish(),
  "lastRecordedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
})

/**
 * Calls the enterprise Policy Document service and streams back the policy PDF for the given policy number. Not cached client-side; the BFF caches the fetched document briefly.
 * @summary Downloads the policy document for a policy number
 */
export const downloadPolicyDocumentPathPolicyNumberMax = 100;



export const DownloadPolicyDocumentParams = zod.object({
  "policyNumber": zod.string().min(1).max(downloadPolicyDocumentPathPolicyNumberMax).describe('Policy number')
})

